import select from 'dom-select'
import { classy as cl } from './classy'
import styles from './mapStyles.json'
import MarkerClusterer from '@googlemaps/markerclustererplus';
import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = window.gmapikey
GoogleMapsLoader.VERSION = '3.47'

function map_recenter(map, latlng, offsetx, offsety) {
  const point1 = map.getProjection().fromLatLngToPoint(latlng);
  const point2 = new google.maps.Point(
    ( (typeof(offsetx) == 'number' ? offsetx : 0) / Math.pow(2, map.getZoom()) ) || 0,
    ( (typeof(offsety) == 'number' ? offsety : 0) / Math.pow(2, map.getZoom()) ) || 0
  );

  map.setCenter(map.getProjection().fromPointToLatLng(new google.maps.Point(
    point1.x - point2.x,
    point1.y + point2.y
  )));
}

const maps = function (parent, onMarkerClick, onClusterClick, onReady) {
  parent = parent || document
  let pageMaps = []
  GoogleMapsLoader.load(function (google) {
    const markerIcon = {
      path: 'M28.7,6.8c-5.2-7-15.2-8.5-22.2-3.3c-1.2,0.9-2.3,2-3.3,3.3c-4.4,5.9-4.4,13.9,0,19.8L16,43.6 l12.7-16.9C33.1,20.8,33.1,12.7,28.7,6.8z M16,7.8c4.7-0.1,8.6,3.7,8.7,8.4c0.1,4.7-3.7,8.6-8.4,8.7c-4.7,0.1-8.6-3.7-8.7-8.4 c0-0.1,0-0.1,0-0.2C7.6,11.7,11.3,7.9,16,7.8z',
      fillColor: '#0A5F9D',
      fillOpacity: 1,
      anchor: new google.maps.Point(16, 22),
      strokeWeight: 0,
      scale: 1
    }

    pageMaps = select.all('.map', parent).map(mapEl => {
      let center
      const position = mapEl.dataset.lat && mapEl.dataset.lng ? new google.maps.LatLng(Number(mapEl.dataset.lat), Number(mapEl.dataset.lng)) : false
      const zoom = mapEl.dataset.zoom ? Number(mapEl.dataset.zoom) : 5
      const pins = mapEl.dataset.pins ? JSON.parse(mapEl.dataset.pins) : []
      let markers = []
      let loaded = false

      if (position) {
        const map = new google.maps.Map(mapEl, {
          center: position,
          zoom: zoom,
          disableDefaultUI: true,
          draggable: true,
          zoomControl: true,
          scrollwheel: false,
          styles: styles
        })

        google.maps.event.addListener(map, 'idle', function () {
          center = map.getCenter()

          if (onReady && !loaded) {
            loaded = true
            onReady()
          }
        })

        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(map, 'resize')
          map.setCenter(center)
        })

        if (pins.length) {
          markers = pins.map(pin => {
            const marker = new google.maps.Marker({
              position: new google.maps.LatLng(Number(pin.lat), Number(pin.lng)),
              map: map,
              draggable: false,
              icon: '/assets/pin-single.svg',
              text: '1'
            })
            marker._city = pin.city;
            marker._id = pin.id;
            marker.addListener("click", () => {
              onMarkerClick(pin.city, pin.id)

              if (map.getZoom() < 8) {
                map.setZoom(17)
                const offset = window.innerWidth >= 1024 ? 200 : window.innerWidth >= 768 ? 100 : 0
                map_recenter(map, marker.position, offset)
              }
            });
            return marker;
          })

          const markerCluster = new MarkerClusterer(map, markers, {
           // imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
            maxZoom: 16,
            gridSize: 20,
            styles: [1, 2, 3].map(() => ({
              url: `data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MS44NSA0NC4zMyI+PHBhdGggZD0iTTE0NS4zNCw2NC4xNmExNS45MywxNS45MywwLDAsMC0yMi4yLTMuMywxNy4xOCwxNy4xOCwwLDAsMC0zLjMsMy4zLDE2LjUsMTYuNSwwLDAsMCwwLDE5LjhsMTIuOCwxNywxMi43LTE2LjlBMTYuNjUsMTYuNjUsMCwwLDAsMTQ1LjM0LDY0LjE2Wm0tMTIuNywxYTguNTUsOC41NSwwLDEsMS04LjQsOC43di0uMkE4LjU0LDguNTQsMCwwLDEsMTMyLjY0LDY1LjE2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNi44IC01Ni43KSIgc3R5bGU9ImZpbGw6IzA5NjA5ZSIvPjxwYXRoIGQ9Ik0xMzIuNjQsNjUuMTZhOC41NSw4LjU1LDAsMSwxLTguNCw4Ljd2LS4yQTguNTQsOC41NCwwLDAsMSwxMzIuNjQsNjUuMTZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA2LjggLTU2LjcpIiBzdHlsZT0iZmlsbDojZmZmIi8+PHBhdGggZD0iTTExNy43OSw4My41M2ExNy4xNywxNy4xNywwLDAsMSwzLjU5LTIzLjY3LDE1LjUsMTUuNSwwLDAsMSw1LjU1LTIuNjEsMTUuNSwxNS41LDAsMCwwLTEzLjM3LDIuNTIsMTcuNiwxNy42LDAsMCwwLTMuMzQsMy4zNEExNy4zMSwxNy4zMSwwLDAsMCwxMTAsODMuNDNMMTIyLjU2LDEwMWw0LTUuMjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA2LjggLTU2LjcpIiBzdHlsZT0iZmlsbDojMDk2MDllIi8+PC9zdmc+`,
              width: 32,
              height: 44,
              textColor: '#0A5F9D',
              fontWeight: 'bold',
              anchorText: [7,4]
            })),
          });

          google.maps.event.addListener(markerCluster, "click", function (c) {
            const offset = window.innerWidth >= 1024 ? 200 : window.innerWidth >= 768 ? 100 : 0
            map_recenter(map, c.center_, offset)
            onClusterClick(c)
          });

        } else {
          new google.maps.Marker({
            position: position,
            map: map,
            icon: markerIcon,
            draggable: false
          })
        }

        return {
          id: mapEl.id,
          map,
          markers,
          reset() {
            map.setZoom(6)
            map.setCenter(position)
          }
        }
      }
    })
  })

  this.reset = function(mapId) {
    const map = pageMaps.find(m => m.id === mapId)
    if (map) {
      map.reset()
    }
  }
  

  this.locationClick = function(id, mapId, zoom) {
    const map = pageMaps.find(m => m.id === mapId)
    if (map) {
      const marker = map.markers.filter(m => m._city === id || m._id === id)
      if (marker.length) {
        const offset = window.innerWidth >= 1024 ? 200 : window.innerWidth >= 768 ? 100 : 0
        // map.map.setCenter(marker.position)
        //Check if single marker or auckland
          //zoom == 17
        //else if more than one marker
          //use fitBounds to get zoom

        if ( marker.length === 1 || id === 'city-auckland') {
          map.map.setZoom(zoom || 17)

          map_recenter(map.map, marker[0].position, offset)

        }else if ( marker.length > 1 ) {

          var bounds = new google.maps.LatLngBounds();
          for (var i = 0; i < marker.length; i++) {
            bounds.extend(marker[i].position);
          }

          map.map.fitBounds(bounds);

        }
      }
    }
  }
}



export default maps
